import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'

import View from '@modul-connect/shared/components/atoms/view'
import { H3, A, Span } from '@modul-connect/shared/components/atoms/text'
import { MdEdit } from 'react-icons/md'
import { FlightModeForm, FlightModeList } from '.'
import { getFutureFlightModes, saveNewFlightMode } from '../../../../../state/actions/vehicles'

import { useAuth0 } from '@auth0/auth0-react'

const FlightModeView = ({ command, fetchFutureFlightModes, saveFlightModeSchedule }) => {
  const { domainId } = useParams()
  const { getAccessTokenSilently } = useAuth0()
  const [showNew, setShowNew] = useState(false)

  useEffect(() => {
    if(domainId)
      getAccessTokenSilently()
        .then(token => fetchFutureFlightModes(token, domainId))
  }, [domainId])

  const handleSave = (cmd) => {
    getAccessTokenSilently()
      .then(token => saveFlightModeSchedule(token, cmd))
      .then(setShowNew(false))
  }

  if(command)
    return (
      <View style={{ float: 'left' }}>
        <div><H3>Flightmode</H3>
          <A
            small
            extend={styles.iconLink}
            onClick={() => setShowNew(true)}
          >
            <MdEdit /><Span>Add scheduled flight mode</Span>
          </A>
        </div>

        <FlightModeList />
        <FlightModeForm show={showNew} flightModeCommand={command} onSave={handleSave} onCancel={() => setShowNew(false)}/>
      </View>
    )
}

const styles = {
  iconLink: ({ theme: { layout, colors } }) => ({
    position: 'relative',
    '> svg': {
      fontSize: 21,
      position: 'absolute',
      left: -3,
      top: -1
    },
    '> span': {
      paddingLeft: 17,
      paddingTop: 3
    }
  }), }


const state2Props = (state) => ({
  command: state.setFlightModeCommand,
})

const dispatchFunctions = dispatch => ({
  saveFlightModeSchedule: (accessToken, cmd) => dispatch(saveNewFlightMode(accessToken, cmd.mainboxId, cmd.telematicsId, `${cmd.date}T${cmd.time}` , cmd.timezone, cmd.duration)),
  fetchFutureFlightModes: (accessToken, domainId) => dispatch(getFutureFlightModes(accessToken, domainId)),
})

export default connect(state2Props, dispatchFunctions)(FlightModeView)